export default __webpack_public_path__ + "static/media/home.76544783.png";